import { connect } from 'react-redux';

import TBReport from './TBReport.js';

const ConnectedTBReport = connect(
  null,
  null
)(TBReport);

export default ConnectedTBReport;
